/* eslint-disable react/no-array-index-key */
import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import Filter from "./Filter";

const filterModel = {
  dataset: "",
  field: "",
  operator: "",
  value: ""
};

const Filters = ({
  datasetsList,
  datasetsFieldsList,
  datasets,
  filters,
  setFilters
}) => {
  const handleGroupAdd = () => {
    const newFilters = [...filters];
    const groupModel = {
      and: [filterModel]
    };
    if (newFilters.length < 1) {
      newFilters.push({ or: [] });
    }
    newFilters[0].or.push(groupModel);
    setFilters(newFilters);
  };

  const handleFilterAdd = (group_index = false) => {
    if (group_index !== false) {
      const newFilters = [...filters];
      newFilters[0].or[group_index].and.push(filterModel);
      setFilters(newFilters);
    } else {
      handleGroupAdd();
    }
  };

  const handleFilterUpdate = (group, index, filter) => {
    const newFilters = [...filters];
    newFilters[0].or[group].and[index] = filter;
    setFilters(newFilters);
  };

  const handleFilterRemove = (group, key) => {
    const newFilters = [...filters];
    newFilters[0].or[group].and = newFilters[0].or[group].and.filter(
      (obj, index) => {
        return index !== key;
      }
    );
    if (newFilters[0].or[group].and.length < 1) {
      newFilters[0].or.splice(group, 1);
    }
    if (newFilters[0].or?.length < 1) {
      newFilters.splice(0, 1);
    }
    setFilters(newFilters);
  };
  return filters.length < 1 ? (
    <div>
      <Button color="primary" outline onClick={() => handleFilterAdd()}>
        Add a Filter
      </Button>
    </div>
  ) : (
    <div>
      {filters[0].or?.map((group, group_index) => (
        <React.Fragment key={`filter-group-${group_index}`}>
          {group_index > 0 && <div className="builder__filter-group-divider" />}
          <div
            className={`builder__filter-group${
              group.and.length > 1 ? " has-label" : ""
            }`}
          >
            <div className="builder__filter-scroll">
              <table className="builder__filter-list">
                <thead>
                  <tr>
                    <th>Dataset</th>
                    <th>Field</th>
                    <th>Operator</th>
                    <th>Value</th>
                    <th aria-label="Remove Filter" />
                  </tr>
                </thead>
                <tbody>
                  {filters[0].or[group_index].and.map(
                    (filter, filter_index) => (
                      <Filter
                        key={`filter-${filter_index}`}
                        index={filter_index}
                        filter={filter}
                        onUpdate={(key, value) =>
                          handleFilterUpdate(
                            group_index,
                            filter_index,
                            key,
                            value
                          )
                        }
                        onRemove={() =>
                          handleFilterRemove(group_index, filter_index)
                        }
                        datasetsList={datasetsList}
                        datasetsFieldsList={datasetsFieldsList}
                        datasets={datasets}
                      />
                    )
                  )}
                </tbody>
              </table>
              <div>
                <Button
                  color="link"
                  size="sm"
                  className="p-0"
                  onClick={() => handleFilterAdd(group_index)}
                >
                  Add a filter
                </Button>
              </div>
            </div>
          </div>
        </React.Fragment>
      ))}
      {filters[0].or?.length > 0 && (
        <div className="builder__filter-group-add">
          <Button color="primary" outline size="sm" onClick={handleGroupAdd}>
            Add a Group
          </Button>
        </div>
      )}
    </div>
  );
};

Filters.propTypes = {
  datasetsList: PropTypes.array,
  datasetsFieldsList: PropTypes.array,
  datasets: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired,
  setFilters: PropTypes.func.isRequired
};

Filters.defaultProps = {
  datasetsList: null,
  datasetsFieldsList: null
};

export default Filters;
